import { endOfMonth, startOfMonth } from 'date-fns'
import { useMemo } from 'react'

import { mainColors, SMedium } from '@avantstay/backoffice-core'

import * as S from '../DatePicker.styles'
import { ViewComponentProps } from '../DatePicker.types'
import { buildAutoScrollableRef, getHalfYearViewPresets } from '../DatePicker.utils'

export const HalfYearView = ({ value, preset, onChange }: ViewComponentProps) => {
  const halfYearViewPresets = useMemo(() => getHalfYearViewPresets(), [])

  const handleSelectPreset = ({
    newPreset,
    halfYear,
    year,
  }: {
    newPreset: string
    halfYear: number
    year: number
  }) => {
    // Convert half-year index to month range
    const referenceStartMonth = halfYear === 0 ? 0 : 6
    const referenceEndMonth = halfYear === 0 ? 5 : 11

    const referenceStartDate = startOfMonth(new Date(year, referenceStartMonth))
    const referenceEndDate = endOfMonth(new Date(year, referenceEndMonth))

    onChange({
      value: { startDate: referenceStartDate, endDate: referenceEndDate },
      metadata: { preset: newPreset },
    })
  }

  return halfYearViewPresets.map(({ year, presets }) => (
    <div key={`half-year-view-${year}`}>
      <SMedium
        color={mainColors.neutralExtraDark}
        ref={buildAutoScrollableRef({ presetYear: year, startDate: value?.startDate })}
      >
        {year}
      </SMedium>

      <S.ViewGrid $columns={2}>
        {presets.map((halfYearViewPreset, index) => (
          <S.ViewPresetButton
            key={`half-year-view-${year}-preset-${halfYearViewPreset}`}
            aria-selected={
              value?.startDate?.getFullYear() === year && halfYearViewPreset === preset
            }
            onClick={() => {
              handleSelectPreset({ newPreset: halfYearViewPreset, halfYear: index, year })
            }}
          >
            {halfYearViewPreset}
          </S.ViewPresetButton>
        ))}
      </S.ViewGrid>
    </div>
  ))
}
